import React, { useEffect, useContext, useState } from 'react';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { hasPhotoLikeComponent, toTop } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import ReactSVG from 'react-svg';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

interface IJigsawButton {
  rootStore?: RootStore;
  isFold?: boolean;
}

const JigsawButton = (props: IJigsawButton) => {
  const {isFold} = props;
  const [visible, setVisible] = useState(false);
  const { mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  // 仅当 active_on=1 时，才展示“Long Pic / Poster”入口
  // 注意：不要在 hooks 之前 return，避免 active_on 在运行期变更导致 hooks 顺序不一致
  const activeOn = Number((window as any)?.configDetail?.active_on);

  const canShowGalleryButtons = () => {
    // 检测一下当前是否有对应的组件之类的
    let { data, video_data } = window.pageDetail;
    if (data) {
      return hasPhotoLikeComponent(window.pageDetail.template || []);
    }

    return false;
  };

  useEffect(() => {
    // 初始检测
    setVisible(canShowGalleryButtons());

    const notifyButtonsChange = (e: any) => {
      let action = (e.action || '') as string;
      if (action == 'tab_no_photo') {
        setVisible(false);
      } 
      if (action == 'tab_has_photo') {
        setVisible(true);
      }
    };

    window.addEventListener('PENDENT_CHANGE', notifyButtonsChange);

    return () => {
      window.removeEventListener('PENDENT_CHANGE', notifyButtonsChange);
    };
  }, []);

  const [showLeft, setShowLeft] = useState(false);
  const toggle = () => {
    setShowLeft(!showLeft);
  };

  useEffect(()=>{
    if(isFold) {
      setShowLeft(true);
    }
  }, [isFold]);

  const setJigsaw = function(type: string) {
    const visibleEvent = new Event('PENDENT_FOLD');
    visibleEvent.data = 1;
    window.dispatchEvent(visibleEvent);
    const activeGallery = activeGalleryInstance.get();
    activeGallery?.setJigsaw({
      type,
      bottomShow: true
    });
    // stat.event(type == 'long' ? 'P_Long' : 'P_Poster');
  };

  if (activeOn !== 1) {
    return null;
  }

  return (
    <NormalButton className={`pendant-jigsaw ` + (!visible && 'hide')}>
      {showLeft ? (
        <div
          className={'left-show'}
          style={{ maxWidth: '100%', opacity: 1 }}
          onClick={toggle}
        >
          <div className={'one-item'} data-stat="P_Long" onClick={() => setJigsaw('long')}>
            {intl.get('Long Pic')}
          </div>
          <div className={'one-item'} data-stat="P_Poster" onClick={() => setJigsaw('poster')}>
            {intl.get('Poster')}
          </div>
          <ReactSVG
            src={require('../../svg/right-arrow.svg')}
            style={{
              fill: pendantIconColor,
              height: 15,
              width: 8,
              paddingLeft: 18
            }}
            className="icon"
          />
        </div>
      ) : (
        <div onClick={toggle}>{intl.get('Jigsaw')}</div>
      )}
    </NormalButton>
  );
};

export default inject('rootStore')(observer(JigsawButton));
